import { combineReducers } from 'redux';
import customer from './customer/customer';
import site from './hierarchy/site/site';
import wellbore from './hierarchy/wellbore/wellbore';
import archive from './hierarchy/archive/archive';
import country from './hierarchy/country/country';
import field from './hierarchy/field/field';
import well from './hierarchy/well/well';
import upload from './upload/upload';
import object from './object/object';
import node from './node/node';
import nodeTree from './hierarchy/node/node';
import design from './hierarchy/design/design';
import designSyncStatus from './hierarchy/design/design-sync-status';
import designSyncCandidates from './hierarchy/design/design-sync-candidates';
import user from './user/user';
import unitTemplates from './unit-templates/unit-templates';
import query from './query/query';
import entityAccessRights from './access-rights/access-rights';
import apiKey from './api-key/api-key';
import anaylytic from './analytics/analytics';
import featureFlags from './feature-flags/feature-flags';
import ipmFiles from './ipm-files/ipm-files';
import version from './version/version';

export default combineReducers({
  site,
  wellbore,
  customer,
  archive,
  country,
  field,
  well,
  object,
  upload,
  node,
  nodeTree,
  design,
  designSyncStatus,
  designSyncCandidates,
  user,
  unitTemplates,
  query,
  anaylytic,
  entityAccessRights,
  apiKey,
  featureFlags,
  ipmFiles,
  version,
});
